<ngx-monaco-editor [options]="editorOptions" style="height: 240px;" [(ngModel)]="mappingModel"></ngx-monaco-editor>
<mat-form-field class="block-comment-container">
  <mat-label>Block Comment</mat-label>
  <textarea type="textarea" rows="3" aria-label="Block Comment" matInput
    [formControl]="blockCommentFormControl" ></textarea>
</mat-form-field>
